import { withRouter } from '../../utils/WithRouter';
import { Paper, Grid, Box } from '@mui/material';

import DoughnutChart from './DoughnutChart';
import ExecutionTable from './ExecutionTable';
// import OptionsComponent from './OptionsComponent';

const DashboardComponent = (props: ChildProps) => {
  const { statusData } = props;

  const cardSx = {
    position: 'relative' as const,
    height: '460px',
    boxShadow: 'none',
    border: '1px solid #e2e2e2',
    borderRadius: '10px',
    '@media (min-width:600px)': {
      height: '600px',
    },
    '@media (min-width:600px) and (max-width:1499.98px)': {
      height: '480px',
    },
  };

  return (
    <Box sx={{ backgroundColor: '#f8f8f6' }}>
      <Grid sx={{ p: { xs: 1, sm: 2 } }} container>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <Paper sx={cardSx} elevation={0}>
            {statusData ? <DoughnutChart statusData={statusData} /> : null}
          </Paper>
        </Grid>
        <Grid
          sx={{
            height: '100%',
            pl: {
              xs: 0,
              sm: 0,
              lg: 2,
            },
            mt: {
              xs: 2,
              lg: 0,
              sm: 2,
            },
          }}
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
        >
          <Paper sx={cardSx} elevation={0}>
            <ExecutionTable />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

interface ChildProps {
  statusData: any;
}

export default withRouter(DashboardComponent);
